import { render, staticRenderFns } from "./84.vue?vue&type=template&id=34080513&scoped=true&"
var script = {}
import style0 from "./84.vue?vue&type=style&index=0&id=34080513&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34080513",
  null
  
)

export default component.exports